var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import defaultHeader from './background-image.jpg';
var HOHeader = /** @class */ (function (_super) {
    __extends(HOHeader, _super);
    function HOHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HOHeader.prototype.getBackgroundImage = function () {
        return defaultHeader;
    };
    HOHeader.prototype.render = function () {
        return (React.createElement("section", { className: 'background-header bg-black', style: { backgroundImage: "url(" + this.getBackgroundImage() + ")" } },
            React.createElement("img", { className: 'header-icon d-none d-xl-block', src: this.props.headerIcon, alt: '' }),
            React.createElement(Container, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }, this.props.children || (React.createElement("ul", { className: 'list-unstyled list-headlines' },
                        React.createElement("li", null,
                            React.createElement("h1", null,
                                "Hetzner ",
                                this.props.headerName,
                                " Developer Hub")),
                        React.createElement("li", null, "Everything developers need"),
                        React.createElement("li", null, "Learn, share, grow."))))))));
    };
    return HOHeader;
}(React.Component));
export { HOHeader };
